import { api_host } from '../constants'
import { apiFetch } from './apiRequestHandler'

export const createComponent = async (data) => {
  return await apiFetch(`${api_host}/comps/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
}

export const updateComponent = async (id, data) => {
  return await apiFetch(`${api_host}/comps/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
}

export const getGlobalComponents = async (page = 0, page_size = 10, searchKey = '') => {
  let url = `${api_host}/comps/globals?skip=${page * page_size}&take=${page_size}`
  if (searchKey) { url += `&name=${searchKey}` }
  return await fetch(url, {
    credentials: 'include'
  }).then(res => res.json())
}

export const offGlobal = async (cids) => {
  return await apiFetch(`${api_host}/comps/off-global`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ cids })
  })
}

export const getComponent = async (id) => {
  return await apiFetch(`${api_host}/comps/get/${id}`, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const getComponentVersions = async (id) => {
  return await apiFetch(`${api_host}/comps/versions/${id}`, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const getComponentVersion = async (id) => {
  return await apiFetch(`${api_host}/comps/get-version/${id}`, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const getComponentByVersion = async (id, version) => {
  return await apiFetch(`${api_host}/comps/version/${id}/${version}`, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
